import { datadogLogs } from "@datadog/browser-logs";
import DeviceUtility from "@/helpers/device";

type DeliveryStage = "rendered" | "load_started" | "playable" | "playing" | "failed";

/** One observation per player/source/stage. URLs and filenames never enter telemetry. */
export function createMediaDeliveryTelemetry() {
	let sourceKey: string | null = null;
	let viewId: string | null = null;
	let startedAt = 0;
	const emitted = new Set<DeliveryStage>();
	return (recordingId: string | undefined, source: string | undefined, stage: DeliveryStage, errorCode?: number) => {
		if (!recordingId || !source) return;
		try {
			const key = `${recordingId}:${source}`;
			if (key !== sourceKey) {
				sourceKey = key;
				viewId = crypto.randomUUID();
				startedAt = performance.now();
				emitted.clear();
			}
			if (emitted.has(stage)) return;
			datadogLogs.logger.info("media.delivery", {
				event: "media.delivery",
				stage,
				viewId,
				recordingId,
				viewerPlatform: DeviceUtility.isIOS ? "web-ios" : DeviceUtility.isAndroid ? "web-android" : "web-desktop",
				elapsedMs: Math.max(0, Math.round(performance.now() - startedAt)),
				...(stage === "failed" && { errorCode: errorCode ?? null })
			});
			emitted.add(stage);
		} catch (error) {
			console.warn("media.delivery: could not record playback evidence", error);
		}
	};
}
